export default __webpack_public_path__ + "static/media/sceneOneDark.2d8044dc.svg";